export const TELEMETRY_COMPONENT = 'EGEM-UI';

export const AUTH_COMPONENT = 'EGEM-UI.Auth';

export const API_COMPONENT = 'EGEM-UI.Api';

export const TELEMETRY_SERVICE = {
  NAME: 'Enterprise Global Event Management',
  LINE: 'Digital Workplace',
  OFFERING: 'End User Services Engineering',
} as const;

export const EVENT_TYPES = {
  BUTTON_CLICK: 'ButtonClick',
  PAGE_VIEW: 'PageView',
  FORM_SUBMIT: 'FormSubmit',
  FORM_ABANDON: 'FormAbandon',
  STEP_CHANGE: 'StepChange',
  SPACE_SELECT: 'SpaceSelect',
  NAVIGATION: 'Navigation',
  UI_INTERACTION: 'UiInteraction',

  START: 'Start',
  END: 'End',
  SUCCESS: 'Success',
  FAILURE: 'Failure',

  ERROR: 'Error',
  EXCEPTION: 'Exception',
  UNHANDLED: 'Unhandled',

  API_CALL: 'ApiCall',
  API_START: 'ApiStart',
  API_END: 'ApiEnd',

  SESSION_WARNING: 'SessionWarning',
  SESSION_IDLE_REACHED: 'SessionIdleReached',
  SESSION_DISMISSED_OUTSIDE_CLICK: 'SessionDismissedOutsideClick',
  SESSION_DISMISSED_ESCAPE: 'SessionDismissedEscape',
} as const;

export const TELEMETRY_PROPERTIES = {
  PAGE_NAME: 'pageName',
  BUTTON_NAME: 'buttonName',
  ACTION_NAME: 'actionName',
  LINK_NAME: 'linkName',
  ERROR_CODE: 'errorCode',
  ERROR_MESSAGE: 'errorMessage',
  API_ENDPOINT: 'apiEndpoint',
  API_METHOD: 'apiMethod',
  HTTP_STATUS: 'httpStatus',
  DURATION_MS: 'durationMs',
  STATUS: 'status',
  OPERATION_NAME: 'operationName',
} as const;

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];
